import { IStyle } from '@fluentui/react';

export interface IFeatureSetJoinStyles {
  root?: IStyle;
  fields?: IStyle;
}

export interface IFeatureSetJoinClassNames {
  root: string;
  fields: string;
}

export const featureSetJoinStylesDefault: Partial<IFeatureSetJoinStyles> = {
  root: {},
  fields: {
    display: 'flex',
    gap: 8,
    '> div': { flex: 1 },
  },
};
